import { CoordinatesAlias } from "constant";

import { getCoordinatesSystem, saveCoordinatesSystem } from "./storage";

export const getCurrentCoordinatesSystem = (): CoordinatesAlias => {
  const data = getCoordinatesSystem();
  return data;
};
export const setCurrentCoordinatesSystem = (
  coordinatesSystem: CoordinatesAlias
): void => {
  saveCoordinatesSystem(coordinatesSystem);
};
